import { DateTime } from 'luxon';
import { UpdateParenthoodVM } from 'mutation/view-models/update-parenthood';
import { GivenHeaderData } from 'shell/models/person';
import { FamilyCoexistence, FamilySubject } from 'shell/models/person/family';

interface MutationFamilyCohabitationRequest {
  testataRichiesta?: GivenHeaderData;
  famigliaConvivenza?: FamilyCoexistence;
  elencoSoggettiFamiglia?: Array<FamilySubject>;
  datiControllo: {
    tipoMutazione: string;
    tipoScheda: string;
  };
}

export const transformMutationUpdateParenthood = (
  subjects: Array<UpdateParenthoodVM>,
  controlDate?: DateTime | null
): MutationFamilyCohabitationRequest => {
  const elencoSoggettiFamiglia = subjects.map((item) => ({
    generalita: item.generality,
    legameSoggetto: {
      codiceLegame: item.relationship,
      tipoLegame: item.linkSubject?.tipoLegame,
      dataDecorrenza: item.linkSubject?.dataDecorrenza,
      progressivoComponente: item.linkSubject?.progressivoComponente,
    },
  }));

  const [subject] = subjects || [];

  const famigliaConvivenza = subject.family ? { ...(subject.family || {}) } : undefined;

  delete famigliaConvivenza?.elencoSoggettiFamiglia;

  return {
    datiControllo: {
      tipoMutazione: '2',
      tipoScheda: '1',
    },
    elencoSoggettiFamiglia,
    famigliaConvivenza,
    testataRichiesta: {
      dataDecorrenza: controlDate?.toFormat('yyyy-MM-dd'),
    },
  };
};
